(function () {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper = [];

    document.querySelectorAll('.swiper-slider').forEach((element, i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`, "");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let TopSlider = new Swiper('.top-content__images-slider', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: false,
        speed: 1600,
        slidesPerView: 1,
    });

    let featuredGallery = new Swiper('.gallery__featured', {
        speed: 700,
        watchSlidesProgress: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        fadeEffect: {
            "crossFade": true
        },
        navigation: {
            nextEl: ".swiper-next-gallery",
            prevEl: ".swiper-prev-gallery",
        },
        breakpoints: {
            900: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
        },
    });

    let cardSlider = new Swiper('.cards-block__items', {
        speed: 700,
        loop: true,
        slidesPerView: 1,
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-next-card",
            prevEl: ".swiper-prev-card",
        },
        breakpoints: {
            769: {
                slidesPerView: "auto"
            }

        }
    });



    let ourPropertiesSlider = new Swiper('.our-properties-block__featured', {
        speed: 700,
        loop: true,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: "fade",
        autoplay: {
            delay: 4000
        },
        fadeEffect: {
            "crossFade": true
        },
        navigation: {
            nextEl: ".swiper-next-properties",
            prevEl: ".swiper-prev-properties",
        },
    });


    let ourRestaurantsSlider = new Swiper('.our-restaurants-block__slider', {
        speed: 700,
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-next-restaurants",
            prevEl: ".swiper-prev-restaurants",
        },
        breakpoints: {
            600: {
                slidesPerView: 3
            }

        }
    });

    let locationTap = document.querySelectorAll('.location-block');
    let locationSlide = document.querySelectorAll('.location-block__items');
    if (locationSlide) {
        const locationSlider = new Swiper('.location-block__items', {
            /*Optional parameters*/
            loop: true,
            allowTouchMove: false,
            navigation: {
                enabled: true,
                nextEl: ".swiper-next-location",
                prevEl: ".swiper-prev-location",
            },
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            },
            breakpoints: {
                600: {
                    navigation: {
                        enabled: false,
                    },
                }
    
            }
        });
        locationTap.forEach(function (hB, hBc) {
            let hNav = hB.querySelectorAll('.location-block__dot');
            let boxL = hB.querySelector('.location-block__box');
            // let textS = hB.querySelector('.location-block__items');
            let boxClose = hB.querySelector('.location-block__item--close');

            hNav.forEach(function (h_nav) {
                let navCount = h_nav.dataset.target;
                h_nav.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (locationTap.length > 1) {
                        locationSlider[hBc].slideTo(navCount, 1000);
                    } else {
                        locationSlider.slideTo(navCount, 1000);
                    }
                    hNav.forEach(function (h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                    if (!boxL.classList.contains('open')) {
                        boxL.classList.toggle('open');
                    }
                });
                boxClose.addEventListener('click', function (e) {
                    boxL.classList.remove('open');
                    hNav.forEach(function (h_nav) {
                        h_nav.classList.remove('active');
                    });
                });
                if (locationTap.length > 1) {
                    locationSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function (h_nav) {
                            let navC = h_nav.dataset.target;
                            h_nav.classList.remove('active');
                            if (locationSlider[hBc].realIndex == navC) {
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    let navIn = 0;
                    locationSlider.on('slideChange', function () {
                        hNav.forEach(function (h_nav) {
                            let navC = h_nav.dataset.target;
                            h_nav.classList.remove('active');
                            if (locationSlider.realIndex == navC && navIn != 0) {
                                h_nav.classList.add('active');
                            }
                            navIn++;
                        });
                    });
                }
            });
        });
    }

    let reviewSlider = new Swiper('.reviews__items', {
        speed: 700,
        loop: true,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination-review",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-next-review",
            prevEl: ".swiper-prev-review",
        },
    });
})();